import { gql } from "apollo-boost";

export const CREATE_CHANNEL_TEAM = gql`
    mutation createChannelTeam($input: CreateChannelTeamInput!) {
        createChannelTeam(input: $input) {
            id
        }
    }
`;

export const UPDATE_CHANNEL_TEAM = gql`
    mutation updateChannelTeam($input: UpdateChannelTeamInput!) {
        updateChannelTeam(input: $input) {
            id
        }
    }
`;

export const DELETE_CHANNEL_TEAM = gql`
    mutation deleteChannelTeam($ids: [ID!]!) {
        deleteChannelTeam(ids: $ids)
    }
`;
